export default __webpack_public_path__ + "static/broderie9.inspirations-d3cb135271f9dde55794f4d65b04198c.jpg";